var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#659C35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#DFE9E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.29 31.871c1.257 0 2.175-.719 2.339-1.8v-.024h-.867l-.008.015c-.16.637-.719 1.036-1.465 1.036-1.016 0-1.648-.84-1.648-2.176v-.008c0-1.34.632-2.18 1.644-2.18.742 0 1.309.45 1.473 1.141v.012h.867l.004-.02c-.149-1.12-1.102-1.906-2.344-1.906-1.566 0-2.539 1.133-2.539 2.953v.008c0 1.816.977 2.95 2.543 2.95zm5.398 0c1.312 0 2.152-.672 2.152-1.75v-.004c0-.836-.485-1.312-1.668-1.566l-.613-.137c-.73-.156-1.028-.43-1.028-.848v-.003c0-.532.489-.84 1.149-.84.683-.004 1.125.332 1.199.793l.008.05h.847l-.004-.054c-.062-.875-.843-1.551-2.039-1.551-1.195 0-2.039.672-2.043 1.645v.003c0 .832.493 1.364 1.637 1.606l.617.133c.746.16 1.051.441 1.051.875v.004c0 .523-.512.882-1.23.882-.754 0-1.297-.328-1.344-.84l-.004-.042h-.86l.005.05c.078.95.894 1.594 2.168 1.594zm4.793-.137h.964l2.008-5.636h-.95l-1.507 4.582h-.066l-1.508-4.582h-.95l2.008 5.636z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.fb2d850c9281c3eaeb5de0e36db88ba0.svg";
export { ForwardRef as ReactComponent };